import type React from 'react'
type Props = {
  imageSrc: string
  heading: string
  message: string
  children?: React.ReactNode
}

/**
 *  @group UI Components
 */
export const ImageWithMessage: React.FC<Props> = ({ imageSrc, heading, message, children }) => {
  return (
    <div className="overflow grid max-h-screen grow grid-rows-2 items-center justify-items-center bg-white lg:grid-cols-3 lg:grid-rows-1">
      <img
        src={imageSrc}
        alt="upside down tractor"
        className="size-full max-h-full max-w-full p-[10%] lg:col-span-2"
      />
      <div className="mx-8 flex w-full min-w-0 shrink flex-col gap-6 px-8 pb-10">
        <h2 className="flex-none text-5xl font-bold text-green-600">{heading}</h2>
        <div className="relative flex-none py-4">
          <div className="text-lg text-gray-900" role="alert">
            {/* TODO: remove alert for all cases not related to actual errors */}
            {message}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
